module.exports = __webpack_public_path__ + "1afb954299dccf5099de26236b14889a.png";